import React from 'react';
import {CardContent, CardMedia,Card, Grid, Link, makeStyles, Typography, Avatar, Icon} from "@material-ui/core";
import mockData from "../mockData";
import github from "../images/github.png";
import { motion } from "framer-motion"



const MyWork = ({title,dark,id,description}) => {

  


    const classes = useStyles();
    return (
        <div className={classes.section}>
            <div  className={classes.sectioncontent} id={id}>
               <Typography variant="h3">{title}</Typography>
               <Grid container className={classes.grid}>
                  {
                    mockData.map(({title,image,link,description},index) =>(
                      <Grid item key={index} xs={10} sm={6} md={4}>
                        <motion.div 
                            animate={{ scale: 0.9 }}
                           >
                        <Card className={classes.card}>
                        <Typography className={classes.title}
                         variant="h6">{title}</Typography>
                          <CardMedia image={image} className={classes.caratula} titulo="caratula"/>
                          <CardContent style={{display:"flex",flexDirection:"row"}}>
                                <Link href={link} color ="primary" target="_blank" rel="noopener noreferrer">
                                <Avatar className={classes.github} variant="square" src={github} />
                                
                                </Link>
                                <Icon/>
                               
                                
                               
                                
                                
                          </CardContent>
                          <div className={classes.contentDesc}>
                           <Typography className={classes.description}
                         variant="h10"> {description} </Typography>
                          </div>
                          
                        </Card>
                        </motion.div>
                        

                      </Grid>
                    ))
                  }
               </Grid>
             </div>
        </div>
            
        
    )
}
const useStyles = makeStyles((theme) => ({ 
    section: {
      background:'#d4d5d6',
       
    },
   
    sectioncontent:{
      textAlign:"center",
      color:"#0c82ad",
      fontWeight:"bold",
      background:"#d4d5d6",
      maxWidth:"90vw",
      margin:"0 auto",
      padding:theme.spacing(3),
      "& h3":{
        
    }, 
    [theme.breakpoints.down("xs")]:{
      marginLeft:"30px"
  },
 
  
 
      
    },
    grid:{
      marginTop:theme.spacing(1),

    },
    card:{
      color:"white",
      
        maxWidth:345,
        minHeight:275,
        margin:theme.spacing(1),
        background:"#e0dede",
        transition:".5s",
        "&:hover":{
           background:"white",
           color:"#1eba8b",
           transform: `translateY(-7px)`
 
        }
       
       
    },
    caratula:{
        objectFit:"cover",
        objectPosition:"center",
        height:"25px",
        paddingTop:'56.25%',
        borderRadius:"30px",
        margin:theme.spacing(2),
        WebkitFilter: 'grayscale(100%)',
        "&:hover":{
          scale:"0.5",
          WebkitFilter: 'grayscale(0)',
        }
        
    },
    github:{
      display:"flex",
      flex:"center",
    
      
      
    },
    title:{
      color:"#white",
       textAlign:"center",
       margin:theme.spacing(1),
       
    },
    description:{
     
      textAlign:"center",
    
      
    },
    contentDesc:{
      
     display:"flex",
     flex:"center",
     margin:theme.spacing(1),
     marginBlockEnd:theme.spacing(3),
    }
   
  }))

export default MyWork;
